import type { FC } from "react";

import { CitationsOverview } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/citations-overview/CitationsOverview";
import { DomainsInfluence } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/DomainInfluence";
import { URLTableComponent } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/url-table/URLTableComponent";
import type { ILLMReport } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export const SourcesReport: FC<ILLMReport> = (reportProps) => {
    return (
        <>
            <CitationsOverview {...reportProps} />
            <DomainsInfluence {...reportProps} />
            <URLTableComponent {...reportProps} />
        </>
    );
};
